import { render } from "./DesktopMenuItemButton.vue?vue&type=template&id=7564307b"
import script from "./DesktopMenuItemButton.vue?vue&type=script&lang=js"
export * from "./DesktopMenuItemButton.vue?vue&type=script&lang=js"

import "./DesktopMenuItemButton.vue?vue&type=style&index=0&id=7564307b&lang=scss"

import exportComponent from "/home/runner/work/pmanastacio/pmanastacio/apps/anastacio_site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__